/** Log types hidden from customer track/trip timelines (mission control keeps full audit). */
const HIDDEN_LOG_TYPES = new Set(["Reviewed Documents"]);

export interface DeliveryLogEntry {
  log_type?: string;
  description?: string;
  log_time?: string;
}

export function filterCustomerDeliveryLogs(logs: unknown): DeliveryLogEntry[] {
  if (!Array.isArray(logs)) return [];
  return logs.filter((log) => !HIDDEN_LOG_TYPES.has(log?.log_type));
}

export function customerActivityLabel(log: DeliveryLogEntry): string {
  if (log.log_type === "Dropped") return "Order delivered";
  const desc = String(log.description ?? "");
  const match = desc.match(/^(.*?)\s+by/i);
  return match ? match[1].trim() : desc;
}
